/**
 * Fragments required to complete a Dark Knowledge cycle before the legendary reward.
 * Authoritative value: `config/exploreUnknownBattleBonuses.json` → bonuses.darkKnowledge.collectParts.targetParts
 * (parity enforced by `__tests__/regression/ExploreUnknown_BattleBonuses_Config_Parity_Regression.js`).
 */
export const EXPLORE_UNKNOWN_DARK_KNOWLEDGE_TARGET_PARTS = 3;
